import type { SupportedFilesTypes } from 'components/file-input/supportedfileTypes';

const reCaptchaPublicKey = process.env.RECAPTCHA_PUBLIC_KEY;

export const TERMS_AND_CONDITIONS_DOC =
  'https://www.tadaah.nl/algemene-voorwaarden/';

export const STATIC_FILES_URL =
  'https://tadaah-public.s3.eu-west-1.amazonaws.com/';

export const DUOPersonRegisterURL = 'https://duo.nl/particulier/kinderopvang/';

export const CompanyInsuranceUrl = 'https://nlzzpverz-yiping.savviihq.com/';

export const KinderopvangWerktUrl =
  'https://www.kinderopvang-werkt.nl/diplomacheck-kinderopvang';

export const LegaliseDiplomaDUOUrl =
  'https://duo.nl/particulier/nederlands-diploma-in-buitenland/legalisatie-diploma.jsp';

export const SUPPORTED_DOC_TYPES: SupportedFilesTypes[] = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
] as SupportedFilesTypes[];

export const RECAPTCHA_RENDER_URL = `https://www.google.com/recaptcha/api.js?render=${reCaptchaPublicKey}`;
export const TADAAH_HOME_MARKETING = 'https://tadaah.nl';
export const TADAAH_HOME = 'https://platform.tadaah.nl/';
